if (typeof AnnouncementBar !== 'function') {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.autoRotateDelay = 4000;
      this.autoRotateInterval = null;

      if (this.length < 2) return; // No need to rotate if there's only one

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
          this.resetAutoRotate();
        });
      }
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
          this.resetAutoRotate();
        });
      }

      this.startAutoRotate();

      this.addEventListener('mouseenter', () => this.stopAutoRotate());
      this.addEventListener('mouseleave', () => this.startAutoRotate());
    }

    changeSlide(direction) {
      this.nextButton?.classList.remove('announcement-bar__content-nav--disabled');
      this.prevButton?.classList.remove('announcement-bar__content-nav--disabled');

      if (direction === 'next') {
        this.index = (this.index + 1) % this.length;
      } else if (direction === 'prev') {
        this.index = (this.index - 1 + this.length) % this.length;
      }

      // Only disable buttons if you want strict control (optional)
      if (this.index === this.length - 1) {
        this.nextButton?.classList.add('announcement-bar__content-nav--disabled');
      } else if (this.index === 0) {
        this.prevButton?.classList.add('announcement-bar__content-nav--disabled');
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

    startAutoRotate() {
      this.autoRotateInterval = setInterval(() => {
        this.changeSlide('next');
      }, this.autoRotateDelay);
    }

    stopAutoRotate() {
      clearInterval(this.autoRotateInterval);
    }

    resetAutoRotate() {
      this.stopAutoRotate();
      this.startAutoRotate();
    }

  }

  if (typeof customElements.get('announcement-bar') === 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}